import pug from 'javascripts/search/templates/create_department.jst.pug';
window.JST = window.JST || {};
window.JST['search/templates/create_department'] = pug;
